import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _Object$keys from 'babel-runtime/core-js/object/keys';
import _getIterator from 'babel-runtime/core-js/get-iterator';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import KeycloakService from './keycloak/KeycloakService';
import RestService from './RestService';
import { PageRoles } from './keycloak/PageRoles';
import logger from 'js-logger';

var UserSettingsService = function () {
  function UserSettingsService() {
    _classCallCheck(this, UserSettingsService);
  }

  _createClass(UserSettingsService, null, [{
    key: 'init',
    value: function init() {
      this.rest = UserSettingsService.initRestService();
    }
  }, {
    key: 'initRestService',
    value: function initRestService() {
      return new RestService();
    }

    /**
     * Returns the user's starting page if set, otherwise returns the default starting page
     * @returns {string}
     */

  }, {
    key: 'getStartingPage',
    value: function getStartingPage() {
      if (!this.userStartingPage) this.setMissingUserStartingPage();
      return this.userStartingPage;
    }

    /**
     * Saves the starting page in the local storage
     * @param page - page to be set as starting page
     */

  }, {
    key: 'saveUserStartingPage',
    value: function saveUserStartingPage(page) {
      this.userStartingPage = page;
      localStorage.setItem('defaultPage', page);
    }

    /**
     * If the user doesn't have a custom starting page set and access to the app's default page
     * than this method sets a starting page that can be accessed by the user.
     */

  }, {
    key: 'setMissingUserStartingPage',
    value: function setMissingUserStartingPage() {
      this.saveUserStartingPage(this.defaultOrFirstAvailable());
    }

    /**
     * Returns either the default starting page or the first available page based on the user's roles.
     * @returns {string}
     */

  }, {
    key: 'defaultOrFirstAvailable',
    value: function defaultOrFirstAvailable() {
      var startingPageToSet = this.defaultStartingPage;
      if (!KeycloakService.isRoleBasedAccessAllowed(PageRoles[startingPageToSet])) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = _getIterator(_Object$keys(PageRoles)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var pageKey = _step.value;

            if (KeycloakService.isRoleBasedAccessAllowed(PageRoles[pageKey])) {
              startingPageToSet = pageKey;
              break;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
      return startingPageToSet;
    }

    /**
     * Returns all available channels. If not already set, takes them from the backend.
     * @returns {array}
     */

  }, {
    key: 'getChannelList',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.channels.length < 1)) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return this.loadChannelList();

              case 3:
                return _context.abrupt('return', this.channels);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getChannelList() {
        return _ref.apply(this, arguments);
      }

      return getChannelList;
    }()

    /**
     * Takes all available channels from the backend and sets them to the local variable.
     */

  }, {
    key: 'loadChannelList',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this.rest.getChannels();

              case 3:
                response = _context2.sent;

                this.channels = response.data;
                _context2.next = 10;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2['catch'](0);

                logger.error(_context2.t0.response.data);

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 7]]);
      }));

      function loadChannelList() {
        return _ref2.apply(this, arguments);
      }

      return loadChannelList;
    }()

    /**
     * Returns the user selected channel.
     * @returns {string}
     */

  }, {
    key: 'getUserChannel',
    value: function getUserChannel() {
      if (this.userChannel === 'ALL') this.clearUserChannel();
      return this.userChannel;
    }

    /**
     * Saves the channel in the local storage and local variable.
     * @param channel
     */

  }, {
    key: 'saveUserChannel',
    value: function saveUserChannel(channel) {
      this.userChannel = channel;
      localStorage.setItem('channel', channel);
    }

    /**
     * Clears the channel in the local storage and local variable.
     */

  }, {
    key: 'clearUserChannel',
    value: function clearUserChannel() {
      this.userChannel = null;
      localStorage.removeItem('channel');
    }
  }]);

  return UserSettingsService;
}();

UserSettingsService.defaultStartingPage = 'CASES';
UserSettingsService.userStartingPage = localStorage.getItem('defaultPage');
UserSettingsService.channels = [];
UserSettingsService.userChannel = localStorage.getItem('channel');
export default UserSettingsService;


// WEBPACK FOOTER //
// ./src/service/UserSettingsService.js